import { Course } from "./types";

export const string2Course = (course: string): Course => {
  switch (course) {
    case "algorithm":
      return Course.ALGORITHM;
    case "algorithm_tangible":
      return Course.ALGORITHM_TANGIBLE;
    case "program":
      return Course.PROGRAM;
    default:
      return Course.ALGORITHM;
  }
};
